__webpack_require__.p = "/react-slot-counter/";